module.exports = __webpack_public_path__ + "img/shoplogo.6dd70123.svg";